import {IFareDiscountType} from "../discount-types/fare-discount-type.interface";
import {AvailableFareModel} from "./available-fare.model";

export class AvailableFareStandardModel extends AvailableFareModel {
    protected _getAvailableDiscountTypes(): IFareDiscountType[] {
        return [];
    }
}
